/**
 * Class description
 *
 * Created: 2018-05-07
 * @author jonas
 */
import {DungeonQuestRealAreaBackgroundView} from "./DungeonQuestRealAreaBackgroundView";
import {DungeonQuestReelAreaAttentionView} from "./DungeonQuestReelAreaAttentionView";
import {DungeonQuestHelper} from "../bigSymbols/DungeonQuestHelper";
import {TimelineLite} from "gsap"
import {DungeonQuestGameMode} from "../DungeonQuestGameConfig";

export class DungeonQuestReelAreaEffectController {
    get reelAreaAttentionView():DungeonQuestReelAreaAttentionView {
        return this._reelAreaAttentionView;
    }

    get reelAreaBackgroundView():DungeonQuestRealAreaBackgroundView {
        return this._reelAreaBackgroundView;
    }

    private readonly _reelAreaBackgroundView:DungeonQuestRealAreaBackgroundView;
    private readonly _reelAreaAttentionView:DungeonQuestReelAreaAttentionView;


    constructor() {
        this._reelAreaBackgroundView = new DungeonQuestRealAreaBackgroundView();
        this._reelAreaAttentionView = new DungeonQuestReelAreaAttentionView();
    }

    public runSpinAnimation(duration:number = 0.5) {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => this._reelAreaBackgroundView.runSpinAnimation(duration));
        return tl;
    }

    public switchBackground(mode:DungeonQuestGameMode, duration:number = 1.5) {
        const tl:TimelineLite = new TimelineLite();
        tl.add(this._reelAreaBackgroundView.switch(mode, duration));
        return tl;
    }

    public getShowBackgroundTint(symbol:string, duration:number = 0.5):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        const color = DungeonQuestHelper.getSymbolColor(symbol);
        tl.add([this._reelAreaBackgroundView.getShowTint(color, duration)]);
        return tl;
    }

    public getHideBackgroundTint(duration:number = 0.5):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([this._reelAreaBackgroundView.getHideTint(duration)]);
        return tl;
    }

    public startReelAreaAttention(color:number = 0xffffff):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            this._reelAreaAttentionView.getShowGlow(0.22, color),
            this._reelAreaBackgroundView.getShowAttention(0.22, color)
        ]);
        return tl;

    }

    public stopReelAreaAttention():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            this._reelAreaAttentionView.getHideGlow(0.3),
            this._reelAreaBackgroundView.getHideAttention(0.3)

        ]);
        return tl;

    }

    public fadeInDarkenPlate(duration:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(this._reelAreaBackgroundView.fadeInDarkenPlate(duration));
        return tl;
    }

    public fadeOutDarkenPlate(duration:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(this._reelAreaBackgroundView.fadeOutDarkenPlate(duration));
        return tl;
    }
}